<template>
    <div>
        <b-container fluid="lg">
            <b-row>
                <b-col>
                    <b-card>
                        <b-overlay :show="loading" rounded="sm">
                            <div class="text-center mb-3">
                                <img class="mb-3 logo" src="/imgs/logoAbelha.png" alt="" />
                            </div>
                            <b-row v-if="user.distribuidor">
                                <b-col cols="10" v-if="user.distribuidor">
                                    <b>Distribuidor: </b> {{ user.distribuidor.codigo }} - {{ user.distribuidor.nome }}
                                </b-col>
                                <b-col cols="2">
                                    <b>Classe:</b> {{ user.distribuidor.classe }}
                                </b-col>
                            </b-row>
                            <b-row v-else>
                                <b-col>
                                    <b>Usuário:</b> {{ user.name }}
                                </b-col>
                            </b-row>
                            <b-row class="mt-3">
                                <b-col class="text-center">
                                    <h4>Sua senha deve ser alterada!</h4>
                                </b-col>
                            </b-row>

                            <b-form @submit.prevent="onSubmit">
                                <b-row>
                                    <b-col>
                                        <b-form-group id="input-group-1" label="Confirme seu email:" label-for="input-1"
                                            description="Endereço de e-mail válido">
                                            <b-form-input id="input-1" v-model="form.email" type="email"
                                                placeholder="email@email.com" required />
                                        </b-form-group>
                                    </b-col>
                                    <b-col>
                                        <b-form-group id="input-group-1" label="Senha atual" label-for="input-1">
                                            <b-form-input id="input-current" type="password" v-model="form.current"
                                                required />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col>
                                        <b-form-group id="input-group-1" label="Nova Senha" label-for="input-1">
                                            <b-form-input id="input-new" type="password" :state="validation"
                                                v-model="form.password" required>
                                            </b-form-input>
                                            <b-form-invalid-feedback :state="validation">
                                                {{ passwordError }}
                                            </b-form-invalid-feedback>
                                            <b-form-valid-feedback :state="validation">
                                                Senha Válida
                                            </b-form-valid-feedback>
                                        </b-form-group>
                                    </b-col>
                                    <b-col>
                                        <b-form-group id="input-group-1" label="Confirmação de Senha"
                                            label-for="input-1">
                                            <b-form-input id="input-confirm" type="password" v-model="form.confirm"
                                                :state="validationConfirm" required />
                                            <b-form-invalid-feedback :state="validationConfirm">
                                                A confirmação não confere com a nova senha
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-button type="submit" variant="primary"><i class="fas fa-save"></i> Salvar</b-button>
                            </b-form>
                        </b-overlay>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
export default {
    data() {
        return {
            user: JSON.parse(document.getElementById('dataUser').value),
            form: {
                email: '',
                confirm: '',
                password: '',
                current: '',
            },
            foods: [{ text: 'Select One', value: null }, 'Carrots', 'Beans', 'Tomatoes', 'Corn'],
            show: true,
            passwordError: '',
            loading: false
        }
    },

    computed: {
        validationConfirm() {
            return this.form.password !== '' && this.form.password == this.form.confirm
        },
        validation() {
            const rules = [
                { test: /.{8,}/, message: "A senha deve ter pelo menos 8 caracteres." },
                { test: /[A-z]/, message: "A senha deve ter pelo menos uma letra." },
                { test: /[0-9]/, message: "A senha deve ter pelo menos um número." }
                //{ test: /[@$!%*?&#]/, message: "A senha deve ter pelo menos um caractere especial." },
            ];
            for (const rule of rules) {
                if (!rule.test.test(this.form.password)) {
                    this.passwordError = rule.message;
                    return false;
                }
            }
            this.passwordError = "";
            return true;
        }
    },

    methods: {
        onSubmit() {
            const vm = this;
            if (!this.form.email) {
                return vm.$swal({
                    title: "Atenção",
                    text: "O e-mail é obrigatório",
                    icon: "error",
                });
            }
            if (!this.form.current) {
                return vm.$swal({
                    title: "Atenção",
                    text: "informe a senha atual",
                    icon: "error",
                });
            }
            if (!this.validation) {
                return vm.$swal({
                    title: "Atenção",
                    text: "A nova senha não atende aos requisitos mínimos de senha",
                    icon: "error",
                });
            }
            if (!this.validationConfirm) {
                return vm.$swal({
                    title: "Atenção",
                    text: "A confirmação de senha é diferente da nova senha",
                    icon: "error",
                });
            }

            vm.loading = true
            axios.post('/reset-password', vm.form)
                .then((response) => {
                    window.location.href = "/";
                }).catch((error) => {
                    let msg = "Erro ao alterar senha!";
                    if (error.response && error.response.data && typeof (error.response.data) == 'string') msg = error.response.data;
                    if (error.response && error.response.data && error.response.data.message && typeof (error.response.data.message) == 'string') msg = error.response.data.message;
                    else if (typeof (error.data) == 'string') msg = error.data;
                    vm.$swal({
                        title: "Atenção",
                        text: msg,
                        icon: "error",
                    });
                    console.log(error)
                }).finally(() => {
                    vm.loading = false
                })
        },
    },

    mounted() {
        this.form.email = this.user.email ? this.user.email : (this.user.distribuidor ? this.user.distribuidor.email : "")
    },
}
</script>

<style>
button {
    width: 100%;
    background-color: #4CAF50;
    color: white;
    padding: 14px 20px;
    margin: 8px 0;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

button:hover {
    background-color: #45a049;
    box-shadow: black;
}

span {
    color: red;
}


@media (max-width: 1000px) {
    .logo {
        display: none;
    }

    .title {
        text-align: justify;
        font-size: 18px;
    }

    .distribuidor {
        text-align: center;
        font-size: 20;
    }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/util/ResetPassword.vue